import axios from "axios";
// this is using middleware to determine state to submit form use formik state https://www.google.com/search?q=import+%7B+actions+%7D+from+%22react-redux-form%22%3B&rlz=1C5OZZY_enGB1137GB1137&oq=import+%7B+actions+%7D+from+%22react-redux-form%22%3B&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIHCAEQIRigAdIBBzQzOWowajeoAgCwAgA&sourceid=chrome&ie=UTF-8
// import { actions } from "react-redux-form";
import { getHeaders } from "../../common/shared";
import { URL } from "../../common/constants";
import Creators from "./actions";
const sendContactFormSuccess = Creators.sendContactFormSuccess;
const sendContactFormError = Creators.sendContactFormError;

const sendContactMessage = (message) => {
  return async (dispatch) => {
    try {
      // api call
      const res = await axios.post(
        `${URL}/v1.0/dashboard-feedback`,
        message,
        getHeaders()
      );
      dispatch(sendContactFormSuccess());
      dispatch(actions.submitFields("contactUs", res));
      dispatch(actions.reset("forms.contactUs"));
    } catch (error) {
      dispatch(sendContactFormError());
    }
  };
};

export default {
  sendContactFormSuccess,
  sendContactFormError,
  sendContactMessage,
};
